var jquery = require("jquery");
window.$ = window.jQuery = jquery;
// var visible = require("jquery-visible");
require('lazysizes');
// require('velocity-animate');
// require('velocity-ui-pack');
require("@fancyapps/fancybox");
import Rellax from 'rellax';
import Swiper from 'swiper/bundle';


var SmoothScroll = require('smooth-scroll');
var scroll = new SmoothScroll('body a:not(.resources-menu)[href*="#"]', {
	updateURL: false,
	easing: 'easeInOutSine',
	speed: 150
});
var scroll = new SmoothScroll('body a.resources-menu[href*="#"]', {
	updateURL: false,
	easing: 'easeInOutSine',
	speed: 150,
    offset: 100,
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();
var timeout; 

$(function () {

    setInterval(function () {
        $('.tagline_eng').toggleClass('tagline_active');
        $('.tagline_maori').toggleClass('tagline_active');
    }, 6000);

	if ($(window).width() >= 1024) {
		var rellaxSlideUp = new Rellax('.slideUp',{
			
		});
		var rellaxSlideUpIn = new Rellax('.slideUpIn',{
			
		});
		var rellaxScrollUp = new Rellax('.scrollUp',{
			breakpoints: [375, 1024, 1280]
		});
		var slideHorizontal = new Rellax('.slideHorizontal', {
			horizontal: true,
		});
	}
	
	$("[data-required]").each(function (index) {
	  $(this).attr('required', true);
	});

	$('.megaSubmenuDropdown').removeClass('hidden');

	var scroll = $(window).scrollTop();

	if (scroll > navbarHeight) {
		$('header').addClass('nav-down');
	}

	setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    if ($('.megaSubmenuDropdown li.active').length) {
        $('.megaSubmenuDropdown li.active').each(function() {
            $(this).closest('.parent-li').addClass('active');
        });
    }

    if ($('.dates-list').length) {
        var datesList = $('.dates-list');
        datesList.each(function() {
            var newH = $(this).find('.dates-row').first().outerHeight();
            $(this).css('height', newH);
        });
    }

});


$(window).on('scroll', function(e) {

    didScroll = true;

	// if ($('.slideUpIn').length && $(window).width() >= 1280) {
	// 	slideUpIn();
	// }

	

});


$(window).on('resize', function() {
	

});


if ($('.slider-home').length) {
	const swiperSimilar = new Swiper('.slider-home', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: true,
		autoHeight: false,
		loop: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
			snapOnRelease: true,
		},
		speed: 400,
		normalizeSlideIndex: true,
		snapOnRelease: true,
		autoplay: false,
        breakpoints: {
            640: {
                slidesPerView: 1.5,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 2.3,
            },
            1280: {
                slidesPerView: 3,
            },
        },
	});
}


if ($('.slider-workshops').length) {
	const swiperWorkshops = new Swiper('.slider-workshops', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		autoHeight: false,
		loop: false,
		navigation: {
			nextEl: '.w-swiper-button-next',
			prevEl: '.w-swiper-button-prev',
		},
		speed: 500,
		normalizeSlideIndex: true,
		snapOnRelease: false,
		scrollbar: false,
		autoplay: false,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1696: {
                slidesPerView: 4,
            },
        },
		on: {
			init: function (swiper) {
				if ($(window).width() >= 640) {
                    setTimeout(function() {                        
                        var maxHeight = 0;
                        var cards = $('.slider-workshops .swiper-slide .workshop-card');
                        cards.each(function() {
                            var thisH = $(this).outerHeight();
                            if (thisH > maxHeight) {
                                maxHeight = thisH;
                            }
                        });
                        $('.slider-workshops .swiper-slide .workshop-card').css('min-height', maxHeight);
                    }, 500);
				}
                var allSlides = $(swiper.slides);
                allSlides.each(function() {
                    if ($(this).find('.workshop-card').length == 0) {
                        $(this).hide();
                        swiper.update();
                    }
                });
			},
		}
	});
	// swiperWorkshops.on('init', function (swiper) {
	// 	console.log('slide changed');
	// });
}

// function slideUpIn() {	
// 	$('.slideUpIn').each(function(){
// 		if ($(this).visible(true)) {
// 			var transform = $(this).css('transform');
// 			if (transform != "none") {
// 				const values = transform.split(',');
// 				const currentYpos = parseInt(values[5].replace(')'));
// 				var maxYpos = parseInt($(this).data('rellax-max'));
// 				var progress = currentYpos / maxYpos;
// 				if (progress <= 1) {
// 					$(this).css('opacity', (1 - progress));
// 				}
// 			}
// 		}
// 	});
// }


if ($(window).width() >= 1280) {

    $('.megaMenu a.parent').on('mouseenter', function(e) {
		var thisElement = $(this);
		if (timeout != null) { clearTimeout(timeout); }

		if (timeout != null) { clearTimeout(timeout); }
		timeout = setTimeout(function () {
            var megaSubmenuDropdown = thisElement.parent().find('.megaSubmenuDropdown').length;

            if (megaSubmenuDropdown) {
                $('body').removeClass('hide-backdrop');
                $('body').addClass('show-backdrop');
                $('.parent-li').removeClass('open');
                $('header').addClass('menu-open');
                thisElement.parent().addClass('open');
            } else {
                if ($('body').hasClass('show-backdrop')) {
                    $('body').removeClass('show-backdrop').addClass('hide-backdrop');    
                    $('.parent-li').removeClass('open');
                    $('header').removeClass('menu-open');
                }
            }
		}, 500);
    });

    $('.megaMenu a.parent').on('mouseleave', function(e) {
		if (timeout != null) { 
			clearTimeout(timeout); 
			timeout = null;
		}
    });

    $('.megaMenu').on('mouseleave', function(e) {
        if ($('body').hasClass('show-backdrop')) {
            $('body').removeClass('show-backdrop').addClass('hide-backdrop');    
			$(this).find('li').removeClass('open');
			$('header').removeClass('menu-open');
        }	
    });
    
}

$('div[data-target-submenu]').on("click", function(e) {
    $('.toplevel').css('transform','translateX(-100%)');
    $('.submenu').css('transform','translateX(-100%)');
    var targetsubmenu = $(this).data('target-submenu');
    $('[data-submenu]').hide();
    $('[data-submenu="' + targetsubmenu + '"]').show();
});

$('.back').on("click", function(e) {
    $('.toplevel').css('transform','translateX(0%)');
    $('.submenu').css('transform','translateX(0%)');
});

$('.asideMenuTrigger').on("click", function(e) {
	showAside($(this), $(this).attr('data-trigger'));
	e.stopPropagation();
    e.preventDefault();
});

$('main').add('footer').add('.backdrop').on("click", function(e) {
	if ($('aside.mobileMenu.menuOpened').length) {
		showAside($('.asideMenuTrigger'), $('.asideMenuTrigger').attr('data-trigger'));
	}
});


$(document).on('click', '[data-enquire]', function(e) {    
    var slug = $(this).data('enquire-slug');
    $.fancybox.open({
        src  : '/enquire/' + slug + '?iframe=true',
        type : 'iframe',
        opts : {
            buttons: ['close'],
            loop: false,
            thumbs: false,
            infobar: false,
            baseClass: "enquire",
            spinnerTpl: '<div></div>',
            btnTpl: {
                smallBtn: '',
                close: '',
                zoom: '',
                arrowLeft: '',
                arrowRight: '',
            },
        }
    });
    e.stopPropagation();
    e.preventDefault();
});


$(document).on('click', '[data-facilitator]', function(e) {    
    var slug = $(this).data('facilitator-slug');
    $.fancybox.open({
        src  : '/team/' + slug + '?iframe=true',
        type : 'iframe',
        opts : {
            buttons: ['close'],
            loop: false,
            thumbs: false,
            infobar: false,
            baseClass: "facilitator",
            spinnerTpl: '<div></div>',
            btnTpl: {
                smallBtn: '',
                close: '',
                zoom: '',
                arrowLeft: '',
                arrowRight: '',
            },
        }
    });
    e.stopPropagation();
    e.preventDefault();
});


$(document).on('click', '[data-appointment]', function(e) {    
    var slug = $(this).data('appointment-slug');
    $.fancybox.open({
        src  : '/appointments/' + slug + '?iframe=true',
        type : 'iframe',
        opts : {
            buttons: ['close'],
            loop: false,
            thumbs: false,
            infobar: false,
            baseClass: "appointment",
            spinnerTpl: '<div></div>',
            btnTpl: {
                smallBtn: '',
                close: '',
                zoom: '',
                arrowLeft: '',
                arrowRight: '',
            },
        }
    });
    e.stopPropagation();
    e.preventDefault();
});


$(document).on('click', '.reveal-dates', function(e) {    
    e.stopPropagation();
    e.preventDefault();
    $(this).toggleClass('open');
    console.log($(this));
    var datesEl = $(this).parent().find('.dates-list');
    if ($(this).hasClass('open')) {
        var h = totalHeight(datesEl);
    } else {
        var h = datesEl.find('div').first().outerHeight();
    }
    datesEl.height(h);
});


$(document).on('click', '.panel-toggle', function(e) {   
    $(".panel.panel-opened").not($(this).parent()).each(function(index) {
        $(this).toggleClass('panel-opened');
        filterExpand($(this));
    });
    $(this).parent().toggleClass('panel-opened');
    filterExpand($(this).parent());
});


$(document).on('click', '.removeFilter', function(e) {   
    $(this).addClass('hidden');
    $(this).next('svg').removeClass('hidden');
});


$(document).on('click', 'aside.filtersPopupClone.cloned [data-filter-option]', function(e) {   
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#workshopFilter").offset().top + 50
    }, 150);
    
    // $('.viewAll svg').removeClass('hidden');
    $('.loader-flex').removeClass('hidden').addClass('flex');

    var filterName = $(this).data('panel-trigger');
    var filterOption = $(this).data('filter-option');
    var filterAction = $(this).data('filter-action');
    if (filterAction == 'add') {
        $('aside#filtersPopup button:not(.removeCheckbox)[data-filter-option="' + filterOption + '"]').trigger('click');
    } else {
        if ($('.removeCheckbox[data-filter-option="' + filterName + '"]').length) {
            $('.removeCheckbox[data-filter-option="' + filterName + '"]').trigger('click');
        }
        if ($('.removeCheckbox[data-filter-option="' + filterOption + '"]').length) {
            $('.removeCheckbox[data-filter-option="' + filterOption + '"]').trigger('click');
        }
    }
    if ($(this).parent().parent().data('panel') != "features") {
        $(this).parent().find('svg').replaceWith('<div class="emptyCheckbox"></div>');
    }
    $(this).find('.emptyCheckbox').replaceWith('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.762 0-5 2.239-5 5v14c0 2.761 2.238 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-8.959 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z" fill="currentColor"/></svg>');

});


$(document).on('click', 'aside.filtersPopupClone.cloned [data-filter-clear]', function(e) {   
    $('.loader-flex').removeClass('hidden').addClass('flex');
    $('aside#filtersPopup [data-filter-clear]').trigger('click');
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#workshopFilter").offset().top + 50
    }, 150);
    $('header').removeClass('nav-down').addClass('nav-up');
});


$(document).on('click', '.filterTrigger', open);


$(document).on('click', '[data-close-popup]', function(e) {   
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#workshopFilter").offset().top + 50
    }, 150);
    $('.filtersPopupClone.cloned.open').removeClass('open');
    $('body').removeClass('overflow-y-hidden');
    $('header').removeClass('nav-down').addClass('nav-up');
    setTimeout(function() {
        $('header').removeClass('nav-down').addClass('nav-up');
    }, 800);
});


$(document).on('click', '[data-booking]', function(e) {   
    var slug = $(this).data('booking-slug');
    $.fancybox.open({
        src  : '/booking/' + slug + '?iframe=true',
        type : 'iframe',
        opts : {
            buttons: ['close'],
            loop: false,
            thumbs: false,
            infobar: false,
            baseClass: "booking",
            spinnerTpl: '<div></div>',
            btnTpl: {
                smallBtn: '',
                close: '',
                zoom: '',
                arrowLeft: '',
                arrowRight: '',
            },
        }
    });
    e.stopPropagation();
    e.preventDefault();
});


function open() {
    if ($('header').hasClass('nav-down')) {
        $('header').removeClass('nav-down').addClass('nav-up');
    }  
    
    $('aside.filtersPopupClone.cloned').addClass('open');
    $('body').addClass('overflow-y-hidden');

    var panel = $(this).data('panel-trigger');
    $('[data-panel].panel-opened').find('.panel-toggle').click();
    $('[data-panel="' + panel + '"]:not(.panel-opened)').find('.panel-toggle').click();
}

function totalHeight(el) {
    var totalHeight = 0;

    el.children().each(function(){
        totalHeight = totalHeight + $(this).outerHeight(true);
    });

    return totalHeight;
}

function showAside(trigger, asideElement) {
	trigger.toggleClass('closed');
	trigger.toggleClass('opened');
	$('body').toggleClass('menuOpened');
	$('main#main').toggleClass('menuOpened');
	$('footer').toggleClass('menuOpened');
	$('aside.mobile'+asideElement).toggleClass('menuOpened');
	$('body').toggleClass('overflow-y-hidden');
	$('main').toggleClass('-translate-x-full lg:-translate-x-1/2');
    if ($('body').hasClass('show-backdrop')) {
        $('body').removeClass('show-backdrop').addClass('hide-backdrop');       
    } else if ($('body').hasClass('hide-backdrop')) {
        $('body').removeClass('hide-backdrop').addClass('show-backdrop');      
    } else {
        $('body').addClass('show-backdrop');      
    }
    var substractHeights = $('.headerContainer').outerHeight() + $('#quick-nav').outerHeight();
    var menuContainerHeight = "calc(100vh - " + substractHeights + "px)";
    $('.megaMenuContainer').css("height", menuContainerHeight);
	trigger.find('.hamburger').toggleClass('is-active');

	var activeLink = $('aside .megaSubmenuDropdown .active');
	if (activeLink.length) {
		var menu = activeLink.closest('.megaSubmenuDropdown').data('submenu');
		var menuHeading = $('[data-target-submenu="' + menu + '"]');
		menuHeading.trigger('click');
	}
}


function hasScrolled() {
	if ($('aside.mobileMenu.menuOpened').length || $('.filtersPopupClone.cloned.open').length) {
		return;
	}
		
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
        
        if(st < 5) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }
    
    lastScrollTop = st;
} 